module.exports = __webpack_public_path__ + "img/order-icon-2.600c2206.png";